const $inputs = document.querySelectorAll('input[type="date"]');

if($inputs) {
  const date = new Date();
  $inputs.forEach(($input) => {
    const minDate = `${date.getFullYear() - 100}-01-01`;
    const maxDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    $input.setAttribute('min', minDate);
    $input.setAttribute('max', maxDate);
    console.log($input);
  });
}
